import React, {Component} from "react";

import {Dimmer, Loader} from "semantic-ui-react";


const BaresthoLoader = () => <Dimmer active><Loader /></Dimmer>;

class DynamicImport extends Component {
    state = {
        component: null
    };
    componentDidMount () {
        this.props.load()
            .then((component) => {
                this.setState(() => ({
                    component: component.default ? component.default : component
                }))
            })
    }
    render() {
        return this.props.children(this.state.component)
    }
}

// PUBLIC APP DYNAMIC IMPORTS
export const Reservation = (props) => (
    <DynamicImport load={() => import('./containers/Reservation/Reservation')}>
        {(Component) => Component === null
            ? <BaresthoLoader/>
            : <Component {...props} />}
    </DynamicImport>
);

export const Order = (props) => (
    <DynamicImport load={() => import('./containers/Order/Order')}>
        {(Component) => Component === null
            ? <BaresthoLoader/>
            : <Component {...props} />}
    </DynamicImport>
);


export const PaymentRedirect = (props) => (
    <DynamicImport load={() => import('./containers/Order/PaymentRedirect')}>
        {(Component) => Component === null
            ? <BaresthoLoader/>
            : <Component {...props} />}
    </DynamicImport>
);


export const UponPickupPaymentRedirect = (props) => (
    <DynamicImport load={() => import('./containers/Order/UponPickupPaymentRedirect')}>
        {(Component) => Component === null
            ? <BaresthoLoader/>
            : <Component {...props} />}
    </DynamicImport>
);


export const Summary = (props) => (
    <DynamicImport load={() => import('./containers/Reservation/Summary')}>
        {(Component) => Component === null
            ? <BaresthoLoader/>
            : <Component {...props} />}
    </DynamicImport>
);

export const OrderSummary = (props) => (
    <DynamicImport load={() => import('./containers/Order/Summary')}>
        {(Component) => Component === null
            ? <BaresthoLoader/>
            : <Component {...props} />}
    </DynamicImport>
);

export const Feedback = (props) => (
    <DynamicImport load={() => import('./containers/Reservation/Feedback')}>
        {(Component) => Component === null
            ? <BaresthoLoader/>
            : <Component {...props} />}
    </DynamicImport>
);


// WEBPACK FOOTER //
// ./src/DynamicImports.js